import CookiesJS from 'cookies-js';

export function initExercises($, apiClient) {
    function extractArrayItems(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push($(this).val());
        });
        return items;
    }

    $('form.exercise-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const images = [];
            $('#images .upload-images__image-container').each(function () {
                images.push($(this).attr('data-key'));
            });
            const exercise = {
                title: $('#title').val(),
                description: $('#description').val(),
                steps: extractArrayItems('steps'),
                images,
                videoUrl: $('#videoUrl').val(),
                equipment: extractArrayItems('equipment'),
                tags: extractArrayItems('tags'),
                deleted: !!$('#deleted').prop('checked'),
            };
            exercise.time = $('#time').val();
            exercise.reps = $('#reps').val();
            exercise.sets = $('#sets').val();
            exercise.rest = $('#rest').val();

            if (!_id) {
                const result = await apiClient.create('/exercises', exercise, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/exercises/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/exercises', _id, exercise, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
